// src/services/outletService.jsx
import http from "./http";

/* ----------------------------------------
   GET ALL OUTLETS
---------------------------------------- */
export const getOutlets = async () => {
  const res = await http.get("getOutlets");
  return res.data;
};

/* ----------------------------------------
   ADD OUTLET
---------------------------------------- */
export const addOutlet = async (payload) => {
  const res = await http.post("addOutlet", {
    outlet_name: payload.outlet_name,
    outlet_phone: payload.outlet_phone,
    outlet_email: payload.outlet_email,
    outlet_status: payload.outlet_status,
    outlet_address: payload.outlet_address,
  });

  return res.data;
};

/* ----------------------------------------
   UPDATE OUTLET
---------------------------------------- */
export const updateOutlet = async (id, payload) => {
  const res = await http.post("updateOutlet", {
    id,
    outlet_name: payload.outlet_name,
    outlet_phone: payload.outlet_phone,
    outlet_email: payload.outlet_email,
    outlet_status: payload.outlet_status,
    outlet_address: payload.outlet_address,
  });

  return res.data;
};

/* ----------------------------------------
   DELETE OUTLET
---------------------------------------- */
export const deleteOutlet = async (id) => {
  const res = await http.post("deleteOutlet", { id });
  return res.data;
};

/* ----------------------------------------
   ✅ GET SINGLE OUTLET (EDIT MODE)
   API: GET get_single_outlet?id=28
---------------------------------------- */
export const getOutletById = async (id) => {
  const res = await http.get(`get_single_outlet?id=${id}`);
  return res.data;
};
